import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#05b6b3',
      dark: '#048b8a',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '10px 20px',
        },
        contained: {
          background: 'linear-gradient(45deg, #05b6b3 30%, #048b8a 90%)',
          color: 'white',
          '&:hover': {
            background: 'linear-gradient(45deg, #048b8a 30%, #05b6b3 90%)',
          },
        },
      },
    },
  },
});

export default theme;